export default __webpack_public_path__ + "static/media/AvenirNextCyr-Light.3f6e7c61.woff";